import useApi from "./useApi";

const useLastThreeDaysRevenue = () => {
  const { get } = useApi();
  return get("/revenue-last-3-days");
};

export default useLastThreeDaysRevenue;
